import { $Locale } from '@lemon8/web-app-shared/atom';
import { RemixBrowser } from '@remix-run/react';
import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { createStore } from 'jotai';

// TODO load all polyfills
// import('intersection-observer');

const LOADER_VERSION = '1';

window.store = createStore();

// init fetch
(() => {
  const originFetch = window.fetch;
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const { region } = window.store.get($Locale);

    if (typeof input === 'string') {
      const u = new URL(input);

      if (u.hostname !== location.hostname) {
        return originFetch(input, init);
      }

      u.searchParams.set('region', region);
      u.searchParams.set('_version', LOADER_VERSION);
      input = u.toString();
    } else if (input instanceof URL) {
      if (input.hostname !== location.hostname) {
        return originFetch(input, init);
      }

      input.searchParams.set('region', region);
      input.searchParams.set('_version', LOADER_VERSION);
    } else if (input instanceof Request) {
      const u = new URL(input.url);

      if (u.hostname !== location.hostname) {
        return originFetch(input, init);
      }

      u.searchParams.set('region', region);
      u.searchParams.set('_version', LOADER_VERSION);
      input = new Request(u.toString(), input);
    }

    return originFetch(input, init);
  };
})();

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
